<template>
  <div class="row">
    <div class="col">
      <div class="form-group">
        <v-select v-model="selectedFilter" :options="filterTypes" @input="updateFilterOptions" class="select-control" :clearable="false" />
        <div class="invalid-feedback">
          <span v-if="isUniqueFilter">This filter cannot be used alongside any other {{ selectedFilter.label }} filters.</span>
          <span v-else>This filter has already been selected.</span>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <v-select
          :disabled="!selectedFilter || !selectedFilter.subFilters"
          :placeholder="(!selectedFilter || !selectedFilter.subFilters) ? 'Please select a filter' : ''"
          :class="validationClass"
          v-model="selectedSubFilter"
          :options="selectedFilter ? selectedFilter.subFilters : []"
          @input="selectFilter"
          :clearable="false"
          class="select-control" />
      </div>
    </div>
    <div class="col">
      <date-picker v-if="selectedSubFilter && selectedSubFilter.type == 'date'"
        :placeholder="selectedSubFilter.placeholder"
        :class="validationClass"
        v-model="selectedValue"
        @input="selectFilter"
        class="ziperase-datepicker"
        format="YYYY-MM-DD"
        value-type="format">
      </date-picker>
      <fg-input v-else-if="selectedSubFilter"
        :type="selectedSubFilter.type"
        :placeholder="selectedSubFilter.placeholder"
        :class="validationClass"
        v-model="selectedValue"
        @input="selectFilter">
      </fg-input>
      <fg-input v-else :disabled="true" placeholder="Please select a filter"></fg-input>
    </div>
    <div class="col-1">
      <button class="btn btn-sm btn-outline-danger" @click="deleteFilter"><font-awesome-icon icon="minus" /></button>
    </div>
  </div>
</template>

<script>
import config from '../../constants/config';
export default {
  name: "SelectFilter",
  props: {
    filterTypes: Array,
    filter: Object,
    index: Number,
    preSelectedFilters: Array
  },
  data() {
    return {
      selectedFilter: null,
      selectedSubFilter: null,
      selectedValue: null,
      isInValid: false
    };
  },
  created() {
    if (this.filter.filterKey) {
      this.selectedFilter = this.filterTypes.find((filter) => {
        return filter.key == this.filter.filterKey;
      });
    }
    if (this.selectedFilter && this.filter.subFilterKey) {
      this.selectedSubFilter = this.selectedFilter.subFilters.find((subFilter) => {
        return subFilter.key == this.filter.subFilterKey;
      });
    }
    if (this.filter.selectedValue) {
      this.selectedValue = this.selectedSubFilter.subFilterType == config.SUBFILTER_DATE ?
        new Date(this.filter.selectedValue) :
        this.filter.selectedValue;
    }
  },
  methods: {
    updateFilterOptions() {
      this.selectedSubFilter = this.selectedFilter.subFilters[0];
      this.selectedValue = null;
      this.selectFilter();
    },
    selectFilter() {
      let subFilterKey = this.selectedSubFilter ? this.selectedSubFilter.key : "";
      this.$emit('selectedFilter', {
        index: this.index,
        selection: {
          filterKey: this.selectedFilter.key,
          subFilterKey: subFilterKey,
          selectedValue: this.selectedValue
        }
      });

      this.validateSelection();
    },
    deleteFilter() {
      this.$emit('deleteFilter', this.index);
    },
    validateSelection() {
      if (!this.selectedSubFilter) {
        this.isInValid = false;
        return;
      }

      let selected = 0;
      for (let i = 0; i < this.preSelectedFilters.length; i++) {
        if (this.isUniqueFilter && this.isSameFilter(this.preSelectedFilters[i])) {
          selected++;
        } else if (this.isSameSubFilter(this.preSelectedFilters[i])) {
          selected++;
        }
      }

      // preselected filters will include this current filter so count must be more than 1 to be invalid
      this.isInValid = selected > 1;
    },
    isSameFilter(filter) {
      return filter.filterKey == this.selectedFilter.key;
    },
    isSameSubFilter(subFilter) {
      return subFilter.subFilterKey == this.selectedSubFilter.key;
    }
  },
  computed: {
    validationClass() {
      return { 'is-invalid': this.isInValid };
    },
    // sub filters which cannot be use alongside any other subfilter
    isUniqueFilter() {
      return this.selectedSubFilter != null &&
        (this.selectedSubFilter.subFilterType == config.SUBFILTER_EQUALS ||
        this.selectedSubFilter.subFilterType == config.SUBFILTER_DATE_RANGE);
    }
  }
}
</script>

<style>
.vs--disabled .vs__dropdown-toggle {
  background: #e3e3e3 !important;
}

.vs__search:disabled {
  background: rgba(0, 0, 0, 0) !important;
}

.vs__open-indicator {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
